<template>
  <div class="slider-management" dir="rtl">
    <div class="container">
      <!-- Header Section -->
      <header class="header">
        <h1 class="page-title">إدارة السلايدر</h1>
        <p class="page-subtitle">قم بإدارة صور العرض الرئيسية للموقع</p>
        <button class="btn-add" @click="openModalForAdd">
          <span class="btn-icon">+</span>
          إضافة صورة جديدة
        </button>
      </header>

      <!-- Gallery Grid -->
      <section class="gallery-grid" v-if="sliders.items.length > 0">
        <div v-for="slider in sliders.items" 
             :key="slider.id" 
             class="gallery-item"
             :class="{ 'is-deleting': slider.isDeleting }">
          <div class="image-container">
            <img
              :src="slider.imageFullUrl || defaultImage"
              :alt="'صورة السلايدر ' + slider.id"
              class="slider-image"
             
            />
            <div class="image-overlay">
              <div class="overlay-actions">
                <button class="overlay-btn edit" @click.stop="openModalForEdit(slider)">
                  <span class="action-icon">✎</span>
                  تعديل
                </button>
                <button class="overlay-btn delete" @click.stop="deleteSlider(slider.id)">
                  <span class="action-icon">×</span>
                  حذف
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Empty State -->
      <div v-else class="empty-state">
        <div class="empty-icon">🖼️</div>
        <h3>لا توجد صور في السلايدر</h3>
        <p>قم بإضافة صور جديدة للعرض في الصفحة الرئيسية</p>
      </div>

      <!-- Add/Edit Modal -->
      <transition name="modal">
        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">
                {{ isEditMode ? "تعديل الصورة" : "إضافة صورة جديدة" }}
              </h2>
              <button class="modal-close" @click="closeModal">&times;</button>
            </div>

            <form @submit.prevent="handleSubmit" class="upload-form">
              <div class="form-group">
                <label class="form-label">صورة السلايدر</label>
                <div 
                  class="file-upload-container" 
                  @dragover.prevent 
                  @drop.prevent="handleFileDrop"
                  @click="$refs.imageInput.click()"
                >
                  <input
                    type="file"
                    ref="imageInput"
                    class="file-input"
                    @change="handleFileChange"
                    accept="image/*"
                    :required="!isEditMode && !form.imageUrl"
                  />
                  
                  <div v-if="!form.theImage && !form.imageUrl" class="upload-placeholder">
                    <span class="upload-icon">↑</span>
                    <span>اضغط أو اسحب صورة هنا</span>
                    <span class="upload-hint">PNG, JPG حتى 5MB</span>
                  </div>

                  <div v-else class="file-preview">
                    <img 
                      :src="previewUrl || form.imageUrl" 
                      alt="معاينة" 
                      class="preview-image"
                    />
                    <button type="button" class="remove-file" @click.stop="removeFile">×</button>
                  </div>
                </div>
              </div>

              <div class="modal-actions">
                <button type="submit" class="btn-submit" :disabled="isSubmitting">
                  <span v-if="isSubmitting" class="spinner"></span>
                  {{ isEditMode ? "تحديث الصورة" : "إضافة الصورة" }}
                </button>
                <button type="button" class="btn-cancel" @click="closeModal">
                  إلغاء
                </button>
              </div>
            </form>
          </div>
        </div>
      </transition>

      <!-- Pagination -->
      <div v-if="sliders.totalPages > 1" class="pagination-container">
        <custom-pagination
          :currentPage="pageNumber"
          :totalPages="sliders.totalPages"
          @page-changed="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";
import CustomPagination from "@/components/CustomPagination.vue";

export default {
  name: "SliderManagement",
  components: { CustomPagination },
  
  data() {
    return {
      sliders: {
        items: [],
        pageNumber: 1,
        totalPages: 1,
        totalCount: 0,
      },
      pageNumber: 1,
      pageSize: 8,
      showModal: false,
      isEditMode: false,
      isSubmitting: false,
      previewUrl: null,
      defaultImage: "/api/placeholder/400/300",
      form: {
        id: null,
        theImage: null,
        imageUrl: null
      },
    };
  },

  methods: {
    async getAllSliders() {
      try {
        const response = await apiClient.get("/api/Slider/GetAllSliders", {
          params: {
            PageNumber: this.pageNumber,
            PageSize: this.pageSize,
          },
        });
        this.sliders = response.data;
      } catch (error) {
        this.showError("حدث خطأ أثناء جلب السلايدرات");
      }
    },

   

    handleFileDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.handleFile(file);
      }
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFile(file);
      }
    },

    handleFile(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.showError("حجم الملف يجب أن يكون أقل من 5 ميجابايت");
        return;
      }
      this.form.theImage = file;
      this.previewUrl = URL.createObjectURL(file);
    },

    removeFile() {
      this.form.theImage = null;
      this.previewUrl = null;
      this.form.imageUrl = null;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },

    async handleSubmit() {
  if (!this.form.theImage && !this.isEditMode) {
    this.showError("الرجاء اختيار صورة");
    return;
  }

  this.isSubmitting = true;
  const formData = new FormData();

  if (this.form.theImage) {
    // Ensure we're appending the actual File object, not an object containing the file
    formData.append("theImage", this.form.theImage);
  }

  try {
    if (!this.isEditMode) {
      await apiClient.post(
        "/api/Slider/AddSlider", 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.showSuccess("تم إضافة الصورة بنجاح");
    } else {
      await apiClient.put(
        `/api/Slider/UpdateSlider?id=${this.form.id}`, 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.showSuccess("تم تحديث الصورة بنجاح");
    }
    this.closeModal();
    this.getAllSliders();
  } catch (error) {
    console.error("Error details:", error);
    this.showError("حدث خطأ أثناء معالجة العملية");
  } finally {
    this.isSubmitting = false;
  }
},

    async deleteSlider(id) {
      const result = await Swal.fire({
        title: "تأكيد الحذف",
        text: "هل أنت متأكد من حذف هذه الصورة؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "نعم، احذفها",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        try {
          // تحديث حالة الصورة قبل الحذف
          const slider = this.sliders.items.find(s => s.id === id);
          if (slider) {
            slider.isDeleting = true;
          }

          await apiClient.delete("/api/Slider/DeleteSlider", {
            params: { id }
          });
          
          this.showSuccess("تم حذف الصورة بنجاح");
          await this.getAllSliders();
        } catch (error) {
          this.showError("حدث خطأ أثناء حذف الصورة");
          // إعادة الحالة في حالة الخطأ
          const slider = this.sliders.items.find(s => s.id === id);
          if (slider) {
            slider.isDeleting = false;
          }
        }
      }
    },

    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: "تم",
        text: message,
        timer: 2000,
        showConfirmButton: false,
      });
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: message,
        timer: 3000,
        showConfirmButton: false,
      });
    },

    openModalForAdd() {
      this.resetForm();
      this.isEditMode = false;
      this.showModal = true;
    },

    openModalForEdit(slider) {
      this.isEditMode = true;
      this.form.id = slider.id;
      this.form.imageUrl = slider.imageFullUrl;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    resetForm() {
      this.isEditMode = false;
      this.isSubmitting = false;
      this.previewUrl = null;
      this.form = {
        id: null,
        theImage: null,
        imageUrl: null
      };
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },

    handlePageChange(newPage) {
      this.pageNumber = newPage;
      this.getAllSliders();
    },
  },

  mounted() {
    this.getAllSliders();
  },
};
</script>

<style scoped>
.slider-management {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: slideDown 0.5s ease-out;
}

.page-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.page-subtitle {
  color: #718096;
  margin-bottom: 1.5rem;
}

.btn-add {
  background: #4299e1;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-add:hover {
  background: #3182ce;
  transform: translateY(-1px);
}

/* Gallery Grid */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.gallery-item {
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  aspect-ratio: 16/9;
  position: relative;
}

.gallery-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slider-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover .slider-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  opacity: 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-end;
  padding: 1.5rem;
}

.gallery-item:hover .image-overlay {
  opacity: 1;
}

.overlay-actions {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  justify-content: center;
  transform: translateY(1rem);
  transition: transform 0.3s ease;
}

.gallery-item:hover .overlay-actions {
  transform: translateY(0);
}

.overlay-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: white;
}

.overlay-btn.edit {
  background: rgba(255, 193, 7, 0.9);
}

.overlay-btn.edit:hover {
  background: #ffc107;
}

.overlay-btn.delete {
  background: rgba(220, 53, 69, 0.9);
}

.overlay-btn.delete:hover {
  background: #dc3545;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 500px;
  position: relative;
  padding: 2rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.modal-title {
  font-size: 1.5rem;
  color: #2d3748;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #2d3748;
}

/* Form Styles */
.upload-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

/* File Upload Styles */
.file-upload-container {
  border: 2px dashed #e2e8f0;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-upload-container:hover {
  border-color: #4299e1;
  background: #ebf8ff;
}

.file-input {
  display: none;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.upload-icon {
  font-size: 2rem;
  color: #4299e1;
}

.upload-hint {
  font-size: 0.875rem;
  color: #718096;
}

.file-preview {
  position: relative;
  margin-top: 1rem;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  border-radius: 0.5rem;
  object-fit: contain;
}

.remove-file {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  background: #fc8181;
  color: white;
  border: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-file:hover {
  background: #f56565;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.btn-submit {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-submit:hover:not(:disabled) {
  background: #3182ce;
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-cancel {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #cbd5e0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin: 2rem 0;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.empty-state h3 {
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.empty-state p {
  color: #718096;
}

/* Spinner */
.spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid #ffffff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Deletion Animation */
.is-deleting {
  animation: fadeOut 0.3s ease-out forwards;
}

/* Animations */
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

/* Pagination */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .slider-management {
    padding: 1rem;
  }

  .header {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }

  .modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .modal-actions {
    flex-direction: column;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
  }
}

/* RTL Specific */
[dir="rtl"] .modal-close {
  left: 1rem;
  right: auto;
}

[dir="rtl"] .remove-file {
  left: -0.5rem;
  right: auto;
}

[dir="rtl"] .modal-actions {
  flex-direction: row-reverse;
}
</style>
